import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { fmtNumber } from "../../utils/i18nFormat";

import "./Overview.css";
import "./overview-signal.css";

/* Colonne droite HOME — design "Signal" 4a (claude.ai/design) */
const Overview = (props) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { isLoggedIn, setShowModal2 } = props;

  return (
    <div className="ov-signal">
      <h1 className="ov-signal__title">{t("signal.ov-title")}</h1>
      <p className="ov-signal__p">{t("signal.ov-p1")}</p>
      <p className="ov-signal__p">
        <span className="ov-signal__brand-a">2FA</span>
        <span className="ov-signal__brand-b">SMS</span> {t("signal.ov-p2")}
      </p>

      <div className="ov-signal__stats">
        <div className="ov-signal__stat">
          <div className="ov-signal__stat-num">183</div>
          <div className="ov-signal__stat-label">{t("signal.stat-countries")}</div>
        </div>
        <div className="ov-signal__stat">
          <div className="ov-signal__stat-num">{fmtNumber(500000, { notation: "compact" }, i18n.language)}</div>
          <div className="ov-signal__stat-label">{t("signal.stat-day")}</div>
        </div>
        <div className="ov-signal__stat">
          <div className="ov-signal__stat-num">{t("signal.stat-delivery-num", { n: fmtNumber(8.2, undefined, i18n.language) })}</div>
          <div className="ov-signal__stat-label">{t("signal.stat-delivery")}</div>
        </div>
      </div>

      <h2 className="ov-signal__h2">{t("signal.how-title")}</h2>
      <div className="ov-signal__steps">
        {[1, 2, 3, 4].map((n) => (
          <div key={n} className="ov-signal__step">
            <span className="ov-signal__step-n">{n}</span>
            <span>{t(`signal.how-${n}`)}</span>
          </div>
        ))}
      </div>

      <h2 className="ov-signal__h2">{t("signal.act-title")}</h2>
      <p className="ov-signal__p ov-signal__p--tight">
        <b>{t("signal.act-activation")}</b> {t("signal.act-activation-body")}
      </p>
      <p className="ov-signal__p">
        <b>{t("signal.act-rent")}</b> {t("signal.act-rent-body")}
      </p>

      <div className="ov-signal__ctas">
        {!isLoggedIn && (
          <button
            className="ov-signal__cta ov-signal__cta--primary"
            onClick={() => setShowModal2(true)}
          >
            {t("signal.cta-create")}
          </button>
        )}
        <button
          className="ov-signal__cta ov-signal__cta--ghost"
          onClick={() => navigate("/api-docs")}
        >
          {t("signal.cta-api")}
        </button>
      </div>
    </div>
  );
};

export default Overview;
